export const notificationFilterFields = {
  RELATED_OBJECT_TYPE: 'relatedObjectType',
};

export const FORM_NOTIFICATIONS_FILTER = 'FORM_NOTIFICATIONS_FILTER';
